import type { InventoryPushChannel } from "@redotech/admin-sdk/rpc/schema/ims/get-inventory-push-settings";
import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { memo } from "react";

export interface InventoryPushChannelStatus {
  channel: InventoryPushChannel;
  /** The team has an enabled integration for this channel. */
  connected: boolean;
  enabled: boolean;
}

const CHANNEL_LABELS: Record<InventoryPushChannel, string> = {
  shopify: "Shopify",
  amazon: "Amazon",
};

export function anyInventoryPushEnabled(
  channels: readonly InventoryPushChannelStatus[],
): boolean {
  return channels.some((channel) => channel.enabled);
}

/** Read-only: merchants turn push on in their Sales channels settings. */
export const InventoryPushStatus = memo(function InventoryPushStatus({
  channels,
}: {
  channels: readonly InventoryPushChannelStatus[];
}) {
  return (
    <Flex dir="column" gap="xs">
      {channels.map(({ channel, connected, enabled }) => (
        <Text fontSize="sm" key={channel}>
          {`${CHANNEL_LABELS[channel]} Inventory Push: ${
            !connected
              ? `No enabled ${CHANNEL_LABELS[channel]} integration`
              : enabled
                ? "On"
                : "Off"
          }`}
        </Text>
      ))}
      <Text fontSize="xs" textColor="tertiary">
        Merchants turn this on in Settings → Inventory management → Sales
        channels.
      </Text>
    </Flex>
  );
});
